import { render, staticRenderFns } from "./shopCart.vue?vue&type=template&id=631fed8a&scoped=true"
import script from "./shopCart.vue?vue&type=script&lang=js"
export * from "./shopCart.vue?vue&type=script&lang=js"
import style0 from "./shopCart.vue?vue&type=style&index=0&id=631fed8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631fed8a",
  null
  
)

export default component.exports